/*
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
*/
// ie 브라우저 호환성 관련 polyfill 추가
import '@babel/polyfill/dist/polyfill.min';
import Vue from 'vue';
import axios from 'axios';
import Bootstrap from 'bootstrap-vue';
import moment from 'moment';
import VueMomentJs from 'vue-momentjs';
import jQuery from 'jquery';
import Popper from 'popper.js';
import Fragment from 'vue-fragment';
import SdlControl from './components/common/control';
import SdlFilters from './filters';
import SdlDirectives from './directives';
import 'bootstrap/dist/js/bootstrap.min';
import App from './App';
import { addEntryPoint, router } from './router';
import store from './vuex/store';
import { i18n } from './i18n';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../static/css/custom.css';
import '../static/css/sdl.css';
import '../static/css/brand.css';
import '../static/css/new-brand.css';
import '../static/css/simple-line-icons.css';
import '../static/css/vue-tabs.css';
import '../static/css/wijmo_custom.css';
import api from './service';
import SDLUtil from '@/utils/SDLUtil';
import '@grapecity/wijmo.styles/wijmo.css';
import '@grapecity/wijmo.vue2.core';
import '@grapecity/wijmo.vue2.input';
import '@grapecity/wijmo.vue2.grid.sheet';
import '@grapecity/wijmo.vue2.nav';
import '@grapecity/wijmo.touch';
import '@grapecity/wijmo.vue2.grid';
import '@grapecity/wijmo.vue2.grid.grouppanel';
import '@grapecity/wijmo.vue2.grid.filter';
import '@grapecity/wijmo.vue2.grid.search';
import '@grapecity/wijmo.grid.cellmaker';
import '@grapecity/wijmo.grid';
import '@grapecity/wijmo.pdf';
import '@grapecity/wijmo.xlsx';
import '@grapecity/wijmo.grid.xlsx';

// eslint-disable-next-line import/order
import { setLicenseKey } from '@grapecity/wijmo';
import * as GC from '@grapecity/spread-sheets';
import '@grapecity/spread-sheets-vue';
import '@grapecity/spread-sheets/styles/gc.spread.sheets.excel2016colorful.css';

console.log('WIJMO LICENSE KEY');
console.log(SDLUtil.WIJMO_LICENCE);

setLicenseKey(SDLUtil.WIJMO_LICENCE);

GC.Spread.Common.CultureManager.culture("ko-kr");
// SPREADJS LICENSE
GC.Spread.Sheets.LicenseKey = SDLUtil.SPREADJS_LICENSE;

// third party libraries used in bootstrap
global.jQuery = jQuery;
global.$ = jQuery;
global.Popper = Popper;

Vue.use(Bootstrap, {});// Vue.use(Bootstrap);
Vue.use(VueMomentJs, moment);
Vue.use(Fragment.Plugin);

Vue.use(SdlControl); // Additional components. common sdl
Vue.use(SdlFilters); // Additional filters. common sdl
Vue.use(SdlDirectives); // Additional directives. common sdl

// Additional context
Vue.prototype.$CONTEXT = SDLUtil.WEB_CONTEXT_PATH;
Vue.prototype.$context = SDLUtil.WEB_CONTEXT_PATH;

Vue.config.productionTip = false;
axios.defaults.headers.common['x-auth-token'] = localStorage.getItem('userToken');
if (localStorage.getItem('adminToken') !== null && localStorage.getItem('adminToken') !== '') {
  axios.defaults.headers.common['original-user-id'] = SDLUtil.parseJwt(localStorage.getItem('adminToken')).userId;
}
// ie, edge https://stackoverflow.com/a/45835054
axios.defaults.headers.common.Pragma = 'no-cache';

axios.interceptors.request.use(
  config => {
    axios.defaults.headers.common['last-access-time'] = localStorage.getItem('lastAccessTime');
    // console.log('request:', localStorage.getItem('lastAccessTime'));
    // Do something before request is sent
    if (Object.prototype.hasOwnProperty.call(config, 'data')) {
      if (Object.prototype.hasOwnProperty.call(config.data, 'labelJson')) {
        config.data.labelJson = JSON.stringify(config.data.labelJson);
      }
    }
    return config;
  },
  error => Promise.reject(error),
);

axios.interceptors.response.use(
  response => {
    if (response.headers.date !== null && response.headers.date !== '') {
      localStorage.setItem('lastAccessTime', new Date(response.headers.date).getTime());
      // console.log('resonse:', localStorage.getItem('lastAccessTime'));
    }

    if (Object.prototype.hasOwnProperty.call(response.data, 'error')) {
      /*
       * Add code number below if error message is passed to login after error message during certain error code
       */
      const loginErrCodes = ['187', '190', '191', '192', '193', '194', '195', '199', '200'];

      // 500 is excluded for error checking when localhost.
      if (window.location.hostname !== 'localhost') {
        loginErrCodes.push('500');
      }
      if (loginErrCodes.includes(String(response.data.error.code))
        && router.currentRoute.fullPath.indexOf('/login') === -1) {
        // Do not process logout when there is a general error
        if (String(response.data.error.code) !== '500') {
          if (String(response.data.error.code) === '194' || String(response.data.error.code) === '195' || String(response.data.error.code) === '187') {
            api.logout();
            document.location = `${SDLUtil.WEB_CONTEXT_PATH}/login?redirect=${window.location.pathname + window.location.search}`;
          } else {
            api.logout();
            document.location = `${SDLUtil.WEB_CONTEXT_PATH}/error?code=${response.data.error.code}&redirect=${router.currentRoute.fullPath}`;
          }
        }
      }

      return Promise.reject(Object.assign(response, new Error(response.data.error.message)));
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 194) {
      window.location = `${SDLUtil.WEB_CONTEXT_PATH}/login?&redirect=${router.currentRoute.fullPath}`;
    }
    return Promise.reject(error);
  },
);

// axios.get('/static/dummy/allMenuPagePaths.json')
axios
  .get(`${SDLUtil.API_URL}/auth/noauth/all-menu-page-paths`)
  .then(({ data }) => {
    addEntryPoint(data).then(() => {
      new Vue({
        router,
        store,
        i18n,
        render: h => h(App),
      }).$mount('#app');
    });
  })
  .catch(err => {
    // TODO network error processing
    console.error(err);
    if (!err.isAxiosError) {
      const search = document.location.pathname + document.location.search;
      if (search && search !== '/') {
        window.location = `${SDLUtil.WEB_CONTEXT_PATH}/login?redirect=${search}`;
      } else {
        window.location = `${SDLUtil.WEB_CONTEXT_PATH}/static/error.html`;
      }
    } else {
      window.location = `${SDLUtil.WEB_CONTEXT_PATH}/static/error.html`;
    }
  });



// WEBPACK FOOTER //
// ./src/main.js